import { render, staticRenderFns } from "./centreLeft1Chart.vue?vue&type=template&id=b9878e7c&scoped=true&"
import script from "./centreLeft1Chart.vue?vue&type=script&lang=js&"
export * from "./centreLeft1Chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9878e7c",
  null
  
)

export default component.exports